var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid",domProps:{"innerHTML":_vm._s(_vm.blogItemsMarkup.join(''))}}),_vm._v(" "),_c('div',{directives:[{name:"inview",rawName:"v-inview:enter",value:(_vm.update),expression:"update",arg:"enter"}]}),_vm._v(" "),(_vm.isUpdating)?_c('div',{staticClass:"spinner"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }